import React from "react";
import { useNavigate } from "react-router-dom";

// Components & Designs
import TitleField from "../text/TitleField";
import TextField from "../text/TextField";
import Button from "../buttons/Button";

// react icons
import { LuMessageSquareMore } from "react-icons/lu";
import { FaArrowRight } from "react-icons/fa";

import Reveal from '../motion/Reveal';

// css
import "../../styles/designs/ContactUsCard.css"


const ContactUsCard = () => {
    const navigate = useNavigate();

    const goToContactUs = () => {
        navigate('/contact');
    };

    const goToProducts = () => {
        navigate('/products');
    };

    return (
        <>
            <Reveal className="contactUsCard-container">
                <div className="contactUsCard-icon-container">
                    <LuMessageSquareMore className='contactUsCard-icon'/>
                </div>

                <div className="contactUsCard-content-container">
                    <div className="contactUsCard-text-container">
                        <TitleField className="contactUsCard-title" title="Ready to Build Something Better?" bold={true}/>
                        <TextField className="contactUsCard-info" text="If you're looking for a partner who understands your community and can deliver software that truly fits, we'd love to hear from you." fontColor="#666666" fontSize="0.95rem"/>
                    </div>

                    <div className="contactUsCard-buttons-container">
                        <Button onClick={goToContactUs}>
                            <span>Start a Conversation</span>
                            <FaArrowRight/>
                        </Button>
                        <Button type="light" onClick={goToProducts}>
                            View Our Products
                        </Button>
                    </div>
                </div>

            </Reveal>

        </>
    )
};

export default ContactUsCard;
